// eslint-disable-next-line import/no-cycle
import getWxConfig from '@/api/wx';
import {
  isIos
} from '@/common/js/utils';
// eslint-disable-next-line import/no-cycle
import store from '@/store/index';

// let appId = '';
// switch (process.env.NODE_ENV) {
//   case 'development':
//     appId = '2';
//     break;
//   case 'alpha':
//     appId = '2';
//     break;
//   case 'production':
//     appId = '2';
//     break;
// }
// export const wxAppId = '2';

/**
 * @description 通过config接口注入权限验证配置，初始化微信js-sdk对象
 * @returns {promise} 初始化成功resolve()，反之reject()
 */
// eslint-disable-next-line import/prefer-default-export
export const initWxConfig = (wxAppId = 2) => {
  let url = window.location.href;

  // （单页面）在IOS上，无论路由切换到哪个页面，实际真正有效的的签名URL是【第一次进入应用时的URL】。
  if (isIos() && sessionStorage.wxBaseUrl) {
    url = JSON.parse(sessionStorage.wxBaseUrl);
  }

  return new Promise((resolve, reject) => {
    // // 是ios系统且已初始化
    // if (isIos() && store.state.isIosInitWxSDK) {
    //   resolve();
    //   return;
    // }
    console.log('initWxConfig appId:', wxAppId);
    getWxConfig(url, wxAppId).then((res) => {
      const signRspData = res.data;

      const configApiList = [
        'hideMenuItems',
        'chooseWXPay',
        'chooseImage',
        'uploadImage',
        'startRecord',
        'stopRecord',
        'uploadVoice',
        'onVoiceRecordEnd',
        'downloadVoice',
        'updateAppMessageShareData', // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
        'updateTimelineShareData', // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
        'showAllNonBaseMenuItem'
      ];

      // eslint-disable-next-line no-undef
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: signRspData.app_id, // 必填，公众号的唯一标识
        timestamp: signRspData.timestamp, // 必填，生成签名的时间戳
        nonceStr: signRspData.nonce, // 必填，生成签名的随机串
        signature: signRspData.sign, // 必填，签名，见附录1
        jsApiList: configApiList, // 必填，需要使用的JS接口列表
      });

      // eslint-disable-next-line no-undef
      wx.ready(() => {
        // ios系统只需要初始化一次
        if (isIos()) {
          store.commit('SET_IOS_WXSDK', true);
        }

        resolve();
      });

      // eslint-disable-next-line no-undef
      wx.error((err) => {
        console.error(err, 'wx: js-sdk初始化失败。');
        reject();
      });
    }).catch((err) => {
      console.error('getWxConfig(): /api/weixin/jssdk_sign  ', err);
      reject();
    });
  });
};
